// extracted by mini-css-extract-plugin
export default {"clients":"Clients_clients__57BV+","logos":"Clients_logos__zIKFS","logo":"Clients_logo__uiJga","confiance":"Clients_confiance__jjhWS"};